var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upvotes-wrapper",on:{"click":function($event){!_vm.feature.has_upvoted ? _vm.$emit('onUpvote', _vm.feature) : _vm.$toast.info('Voto já computado')}}},[_c('ArrowUp',{staticClass:"arrow-up",class:{ active: !_vm.feature.has_upvoted }}),_c('div',[_vm._v(_vm._s(_vm.parseValue(_vm.feature.upvotes)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }